import { FC, Fragment, useRef, useState } from "react"
import { Box, Card, Flex, Heading, Button, Text } from "rebass/styled-components"
import styled from "styled-components";
import Header from "../components/Header"
import { gql, useMutation, useQuery } from "@apollo/client";
import ReactSelect from "react-select";
import { ReactSelectStyles } from "../styles/ReactSelectStyles";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import IconLoading2 from "../components/icons/IconLoading2";
import { Checkbox } from "../components/CheckboxInput";
import FullLayoutAnimated from "../components/FullLayoutAnimated";
import { MotivationalQuote } from "../components/MotivationalQuote";
import { RbCircledChecked, RbCircledUnchecked } from "../components/RadioButton";

const Container2 = styled(Flex)`
  flex:1;
  flex-direction:column ;
  background: rgba(255, 255, 255, 0.45);  
  backdrop-filter: blur(10px);  
  -webkit-backdrop-filter: blur(10px); 
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  @media (max-width: 1050px) {
    background:transparent !important ;
  }
`;

const Container = styled(Flex)`
  flex:1;
  flex-direction: column;
  @media (max-width: 1050px) {
      display: none;
  }
`;
const Cards = styled(Card)`

  background:white;
  @media (min-width: 1051px) {
    background:transparent;
    border: 0 ;
    box-shadow: unset;
    padding: 0 ;
  }
`

const CardContainer = styled(Flex)`
  max-width: 400px;
`;

const LogoutWrap = styled(Box)`
  background: rgb(232 232 232 / 0%);
  margin-bottom: -32px;
  opacity: 0.7;
  transition: 0.3s;
  color: #eba400;
  padding: 6px;
  border-radius: 12px;
  cursor: pointer;
  border: 1px solid #eba400;

  &:hover {
    background: #eba400;
    color: white;
    opacity: 1;
  }
`

const IMPERSONATE = gql`
  mutation impersonateHealthCoach($id: String!){
    impersonateHealthCoach(id: $id) {
      token
      user {
        id
        accountLocked
      }
    }
  }
`

interface IImpersonateOutput {
  impersonateHealthCoach: {
    token: string
    user: {
      id: string,
      accountLocked: boolean
    }
  }
}

const GET_HELPSCOUT_USERS = gql`
  query getHealthCoachUsersFromAdmin {
    getHealthCoachUsersFromAdmin {
      id
      name
      email
      phone
      isOnboarded
      isActive
    }
  }
`;

interface IHelpscoutUser {
  id: string
  name: string
  email: string
  phone: string
  isOnboarded: boolean
  isActive: boolean
}

interface IGetHelpscoutUsersOutput {
  getHealthCoachUsersFromAdmin: IHelpscoutUser[];
}

interface IIGetHelpscoutUsersInput { }

interface IImpersonateInput {
  id: string
}

const ImpersonatableWrap = styled(Flex)`
  padding: 8px 12px ;
  border: 1px solid #9aace8;
  border-radius: 8px ;
  width: 100%;
  align-items:center;
  cursor: pointer ;
  &:hover {
    background: #d9deee;
    /* color: white; */
    opacity: 1;
  }
`

const Impersonatable: FC<{ provider: IHelpscoutUser, isSelected?: boolean, onClick: (provider: IHelpscoutUser) => void }> = ({ provider, isSelected, onClick }) => {

  return (
    <ImpersonatableWrap onClick={() => {
      onClick(provider)
    }}>
      {isSelected ? (
        <RbCircledChecked />
      ) : <RbCircledUnchecked />}

      <Text ml={2}>{provider.name}</Text>
    </ImpersonatableWrap>
  )
}

const Impersonate = () => {
  const navigate = useNavigate()
  const [impersonateProvider, setImpersonateProvider] = useState<string>();
  const [scrambleData, setScrambleData] = useState<boolean>(false)
  const { data, loading, error } = useQuery<IGetHelpscoutUsersOutput, IIGetHelpscoutUsersInput>(GET_HELPSCOUT_USERS)
  const [impersonate, { loading: loadingImpersonate }] = useMutation<IImpersonateOutput, IImpersonateInput>(IMPERSONATE, {
    onError: () => {
      toast.update(toastId.current, {
        render: 'An error occured',
        type: toast.TYPE.ERROR,
        isLoading: false,
        autoClose: 5000,
        closeButton: null // The closeButton defined on ToastContainer will be used
      });
    }
  })
  const toastId = useRef<any>(null);

  const handleImpersonate = async () => {
    localStorage.removeItem('scramble')
    if (!data || !data.getHealthCoachUsersFromAdmin || !impersonateProvider) return
    const userToImpersonate = data?.getHealthCoachUsersFromAdmin.find(x => x.id.toString() === impersonateProvider)
    if (!userToImpersonate || !userToImpersonate.id) return
    toastId.current = toast(<Flex flexDirection={'column'}>
      <Text fontWeight={400}>Impersonating</Text>
      <Text fontWeight={300}>{`${userToImpersonate?.name}`}</Text>
    </Flex>, { autoClose: false, isLoading: true, closeButton: false });
    const initialToken = localStorage.getItem('token');
    let impersonateResult = await impersonate({
      variables: {
        id: userToImpersonate.id.toString()
      },
    });
    if (!impersonateResult || !impersonateResult.data || !impersonateResult.data.impersonateHealthCoach.token) {
      toast.update(toastId.current, {
        render: 'An error occured',
        type: toast.TYPE.ERROR,
        isLoading: false,
        autoClose: 5000,
        closeButton: null // The closeButton defined on ToastContainer will be used
      });
      return
    }
    if (scrambleData) {
      localStorage.setItem('scramble', 'true')
    }
    localStorage.setItem('initialToken', initialToken || '');
    localStorage.setItem('token', impersonateResult.data.impersonateHealthCoach.token);
    toast.update(toastId.current, {
      render: 'Impersonation succeeded!',
      type: toast.TYPE.SUCCESS,
      isLoading: false,
      autoClose: 5000,
      closeButton: null // The closeButton defined on ToastContainer will be used
    });
    navigate('/')
  }
  return (
    <FullLayoutAnimated style={{ overflow: 'hidden', zIndex: 10 }}>
      <Flex style={{ width: '100vw', height: '100vh' }}>

        <Container2 >
          <Flex flexDirection="column">
            <Header dark={false} childContainerStyle={{ marginTop: '-16px' }}>

              <Heading sx={{ marginLeft: '97px' }}>Health Coaches</Heading>
            </Header>
          </Flex>
          <Flex flex={1} mt={'-120px'} alignItems="center" justifyContent="center">
            <CardContainer flex={1} px={3}>
              <Cards p={4}>
                <Flex flexDirection="column">
                  {!!loading || !!loadingImpersonate ? (
                    <IconLoading2 style={{ width: '300px', height: 'auto' }} />
                  ) : (<>
                    <Box>
                      <Heading textAlign="center" mb={4}>
                        Choose Care Manager to Impersonate
                      </Heading>
                    </Box>
                    <Fragment>
                      {!loading && (
                        // <Flex flexDirection={'column'} style={{ overflow: 'auto', gap: '8px' }}>
                        //   {data?.getHealthCoachUsersFromAdmin.map(x => (
                        //     <Impersonatable provider={x} key={x.id} onClick={provider => {
                        //       setImpersonateProvider(provider.id)
                        //     }} isSelected={!!impersonateProvider && impersonateProvider === x.id}
                        //     />
                        //   ))}
                        // </Flex>
                        <ReactSelect
                          styles={{ ...ReactSelectStyles.initialStyles }}
                          options={(data?.getHealthCoachUsersFromAdmin || [] as IHelpscoutUser[]).map(x => {
                            return {
                              label: `${x.name}`,
                              value: x.id.toString()
                            }
                          })}
                          onChange={e => {
                            if (!e) {
                              return
                            } else {
                              setImpersonateProvider(e.value)
                            }
                          }}
                          placeholder='Pick care manager...'

                        />
                      )}
                      <Flex mt={3} />
                      <Checkbox label='Scramble data' isChecked={scrambleData} onClick={() => { setScrambleData(!scrambleData) }} />

                      <Button mt={4} disabled={!!loading || !impersonateProvider} width={'100%'} style={{ borderRadius: '10px' }} onClick={handleImpersonate}>Impersonate</Button>
                      <LogoutWrap mt={5}
                        onClick={() => navigate('/logout')}>

                        <Text
                          style={{ textAlign: 'center' }}
                        >Logout</Text>
                      </LogoutWrap>
                    </Fragment>
                  </>)}
                </Flex>
              </Cards>
            </CardContainer>
          </Flex>
        </Container2>

        <Container >
          <Flex flex={1} alignItems="center" justifyContent="center">
            <MotivationalQuote />
          </Flex>

        </Container>
      </Flex>
    </FullLayoutAnimated>
  )
}

export default Impersonate